import {Component} from "@angular/core";
import {Page} from "../../orchestration/page";
import {NavigationParams} from "../../orchestration/navigation-params";

@Component({
    selector: "woa-legal-page",
    templateUrl: "./legal-page.component.html",
    providers: [{provide: Page, useExisting: LegalPageComponent}]
})
export class LegalPageComponent extends Page {
    public display: "terms" | "privacy";

    constructor(navigationParams: NavigationParams) {
        super();
        this.display = navigationParams.get("display");
    }
}



// WEBPACK FOOTER //
// ./src/app/legal/legal-page/legal-page.component.ts